import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

const productText = {
  fontWeight: 600,
  fontSize: '1rem',
  lineHeight: '1.5rem',
  color: neutral[100],
};

export default makeStyles({
  productList: {
    listStyle: 'none',
    margin: 0,
    padding: '1rem 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  productItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    height: '1px',
    backgroundColor: neutral[20],
    border: 'none',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    flexShrink: 0,
  },
  productHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '1rem',
  },
  productNameRow: {
    display: 'flex',
    gap: '0.5rem',
    flex: 1,
    minWidth: 0,
    alignItems: 'flex-start',
  },
  productUnits: {
    ...productText,
    flexShrink: 0,
  },
  productName: {
    ...productText,
    minWidth: 0,
    wordBreak: 'break-word',
  },
  productPrice: {
    ...productText,
    flexShrink: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  productDescription: {
    margin: 0,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },
  toppings: {
    margin: '0.75rem 0 0 1.25rem',
    display: 'flex',
    flexDirection: 'column',
  },
  toppingCategory: {
    margin: 0,
    color: neutral[80],
    fontWeight: 400,
    fontSize: '0.75rem',
    '&:not(:first-child)': {
      marginTop: '0.5rem',
    },
  },
  toppingDetail: {
    display: 'flex',
    flexDirection: 'column',
  },
  toppingRow: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',
  },
  toppingDescription: {
    margin: 0,
    color: neutral[100],
    fontWeight: 500,
    fontSize: '0.875rem',
    minWidth: 0,
  },
  toppingPrice: {
    margin: 0,
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral[60],
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
});
